"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingCoreChargeCancelReasonEnum = void 0;
/**
 * Причины отмены
 */
var BillingCoreChargeCancelReasonEnum;
(function (BillingCoreChargeCancelReasonEnum) {
  /** Отменил покупатель */
  BillingCoreChargeCancelReasonEnum["CUSTOMER_REFUSED"] = "CUSTOMER_REFUSED";
  /** Отменил продавец */
  BillingCoreChargeCancelReasonEnum["SELLER_REFUSED"] = "SELLER_REFUSED";
  /** Дубликат */
  BillingCoreChargeCancelReasonEnum["DUPLICATE"] = "DUPLICATE";
  /** Иное */
  BillingCoreChargeCancelReasonEnum["OTHER"] = "OTHER";
})(BillingCoreChargeCancelReasonEnum = exports.BillingCoreChargeCancelReasonEnum || (exports.BillingCoreChargeCancelReasonEnum = {}));
